import { stripDiacritics } from './strip-diacritics';

export const slugify = (str: string): string => {
  return stripDiacritics(str)
    .toLowerCase()
    .replace(/[^.a-z0-9_-]+/gi, '-')
    .replace(/-+/g, '-')
    .replace(/-+$/, '')
    .replace(/^-+/, '');
};
